
import Vue from "vue";
import AppDraggable from "./Draggable.vue";

export default Vue.extend({
	data() {
		return {
			val: 0
		};
	},
	props: {
		value: Number,
		useBottom: Boolean
	},
	watch: {
		value: {
			immediate: true,
			handler(val: number) {
				this.val = val;
			}
		},
		val(val: number) {
			this.$emit("input", val);
		}
	},
	components: {
		AppDraggable
	}
});
